<main id="main">
    <kokos-header [page]="page" [title]="'readmail.title' | i18next"></kokos-header>
    <div i18nRerenderOnLanguageChange></div>
    <div class="container-fluid ba-mailbox ba-mail-view">
        <div class="row">
            <div class="col-12 col-lg-8">
                <div class="ba-tile">
                    <pf-nachricht-detail
                            [nachrichtId]="nachricht.nachrichtId"
                            [dateTime]="getPostfachFormat(nachricht.datum)"
                            [sender]="personDisplayService.displayName(nachricht.senderName, nachricht.senderId)"
                            [autor]="personDisplayService.displayName(nachricht.autorName, nachricht.autorId)"
                            [empfaenger]="personDisplayService.displayName(nachricht.empfaengerName, nachricht.empfaengerId)"
                            [text]="sanitizedText"
                            [betreff]="nachricht.betreff"
                            [anhaenge]="getAnhaenge()"
                            [nachrichtActions]="getNachrichtActions()"
                            (downloadClicked)="downloadAnhang($event)"
                            (buttonClicked)="onNachrichtActionButtonClicked($event, nachricht)"
                    ></pf-nachricht-detail>
                </div>
                <pf-nachricht-action-modals
                    #nachrichtActionModals
                    (reload)="onReload($event)"
                />
            </div>
        </div>

        @if (nachricht.historie?.length) {
            <kokos-nachricht-history [nachrichtHistorie]="nachricht.historie" [nachricht]="nachricht"/>
        }

        <pf-footer [backButton]="backButtonConfig" (backButtonClicked)="handleBackClicked()"></pf-footer>

    </div>
</main>